export enum NUMBER_FORMAT_TYPE {
    GENERAL = 'auto', // 常规
    TEXT = 'text', // 纯文本 formatting, e.g 1000.12
    NUMBER = 'number', // 数值 formatting, e.g, 1,000.12
    PERCENT = 'percent', // 百分比 formatting, e.g 10.12%
    CURRENCY = 'currency', // 货币 formatting, e.g $1,000.12
    DATE = 'date', // 日期 formatting, e.g 9/26/2008
    TIME = 'time', // 时间 formatting, e.g 3:59:00 PM
    DATE_TIME = 'date-time', // 日期 + 时间 formatting, e.g 9/26/08 15:59:00
    FRACTION = 'fraction', // 分数
    SCIENTIFIC = 'scientific', // 科学记数 e.g 1.01E+03
    ACCOUNTING = 'accounting', // 会计专用
    SPECIAL = 'special', // 特殊 包括（邮编，中文大小写）
    CUSTOM = 'custom', // 自定义
}
